import { createFileRoute, redirect } from '@tanstack/react-router';

import { meetingApis } from '@/features/meetings/meetings.query';
import { logError } from '@/lib/errorLogging';
import { AppCapability, isCapable } from '@/utils/capabilities';

export const Route = createFileRoute('/_authenticated/meetings')({
  beforeLoad({ location }) {
    if (
      !isCapable(AppCapability.MeetingNotes) &&
      location.pathname !== '/meetings'
    )
      throw redirect({ to: '/meetings' });
  },
  onLeave() {
    void meetingApis
      .cleanupEmptyMeetings()
      .catch((error) => logError(error, 'unable to prune empty meetings'));
  },
});
